import React from 'react';
import { Elements } from 'react-stripe-elements';
import StripeForm from './StripeForm';
import './payment.scss';

export default ({ newCard }) => (
  <Elements>
    <StripeForm newCard={newCard} />
  </Elements>
);
